import React, { useState } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import Pagetitlesection from "../components/pagetitlesection";
import homebanner from "../assets/home-banner.png"; 

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      setStatus("⚠️ Please complete the reCAPTCHA.");
      return;
    }

    try {
      const res = await axios.post("/php-api/contact.php", {
        ...formData,
        recaptcha: recaptchaToken
      });

      if (res.data.success) {
        setStatus("✅ Message sent successfully!");
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        setRecaptchaToken("");
      } else {
        setStatus(`❌ ${res.data.message || "Message not sent."}`);
      }
    } catch {
      setStatus("❌ Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <Header />
      <div className="page-body-container bg-gray-100"> 
          <Pagetitlesection title="Contact Us" backgroundImage={homebanner} />
      <div className="bg-gray-50 py-12 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          
          {/* Left Panel - Contact Info */}
          <div className="bg-white shadow-lg rounded-lg p-6 space-y-6">
            <h2 className="text-2xl font-bold text-primarycolor mb-4">Get in Touch</h2>

           

            <div className="flex items-start space-x-3">
              <FaMapMarkerAlt className="text-primarycolor mt-1" />
              <div>
                <h4 className="font-semibold">Giffypedia Headquarters</h4>
                <p>
                  27/12 Mancholai 2nd st, <br/> Ekkattuthangal, 
                 Chennai -32,<br /> Tamil Nadu, India.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <FaEnvelope className="text-primarycolor mt-1" />
              <div>
                <h4 className="font-semibold">Email</h4>
                <p>giffypedia@gmail.com</p>
              </div>
            </div>

             <div className="flex items-start space-x-3">
              <FaPhoneAlt className="text-primarycolor mt-1" />
              <div>
                <h4 className="font-semibold">Phone</h4>
                <p>+91 78455 60147</p>
              </div>
            </div>

          </div>

          {/* Right Panel - Contact Form */}
          <div className="md:col-span-2 bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold text-primarycolor mb-4">Contact With Us</h2>
            {status && <p className="mb-4 text-red-600 font-semibold">{status}</p>}
            
            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="Name*"
                value={formData.name}
                onChange={handleChange}
                required
                className="p-3 border border-gray-300 rounded-md focus:ring focus:outline-none"
              />
              <input
                type="email"
                name="email"
                placeholder="Email*"
                value={formData.email}
                onChange={handleChange}
                required
                className="p-3 border border-gray-300 rounded-md focus:ring focus:outline-none"
              />
              <input
                type="text"
                name="phone"
                placeholder="Phone*"
                value={formData.phone}
                onChange={handleChange}
                required
                className="p-3 border border-gray-300 rounded-md focus:ring focus:outline-none"
              />
              <input
                type="text"
                name="subject"
                placeholder="Subject*"
                value={formData.subject}
                onChange={handleChange}
                required
                className="p-3 border border-gray-300 rounded-md focus:ring focus:outline-none"
              />
              <textarea
                name="message"
                placeholder="Your Message*"
                value={formData.message}
                onChange={handleChange}
                required
                className="p-3 border border-gray-300 rounded-md md:col-span-2 h-32 resize-none focus:ring focus:outline-none"
              ></textarea>

              <div className="md:col-span-2">
                <ReCAPTCHA
                  sitekey="6LeQgv4UAAAAADXZOtgpI5_EIC7Av7CUjB5K8zdP"
                  onChange={(token) => setRecaptchaToken(token)}
                />
              </div>

              <div className="md:col-span-2 text-right">
                <button
                  type="submit"
                  className="primarybutton"
                >
                  SEND MESSAGE
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
      </div>
    </>
  );
}

export default Contact;
